<template>
  <div>
    <div class="list">
      <div class="item" v-for="(item, index) in list" :key="index">
        <dynamicUser :datas="item" v-if="item.tag == '客户数-活跃客户数'" />
        <userConversionRate :datas="item" v-else-if="item.tag == '客户数-新客户转化率'" />
        <individualPerformance :datas="item" v-else-if="item.tag == '业绩-业绩百分比' || item.tag == '业绩-公司业绩百分比'" />
        <indemnityRatio :datas="item" v-else-if="item.tag == '赔款-赔款比例'" />
        <inTheDepartment :datas="item" v-else-if="item.tag == '业绩-部课内业绩一览'" />
        <proportionOfIncomingCustomers :datas="item" v-else-if="item.tag == '客户数-流入客户比例'" />
        <departmentalPerformance :datas="item" v-else-if="item.tag == '业绩-部门业绩一览'" />
      </div>
    </div>
  </div>
</template>
<script>

import dynamicUser from './dynamicUser'
import userConversionRate from './userConversionRate'
import individualPerformance from './individualPerformance'
import indemnityRatio from './indemnityRatio'
import inTheDepartment from './inTheDepartment'
import proportionOfIncomingCustomers from './proportionOfIncomingCustomers'
import departmentalPerformance from './departmentalPerformance'

export default {
  components: {
    dynamicUser,
    userConversionRate,
    individualPerformance,
    indemnityRatio,
    inTheDepartment,
    proportionOfIncomingCustomers,
    departmentalPerformance
  },
  props: {
    list: { type: Array },

  },
  data() {
    return {


    };
  },
  created() {

  },
  mounted() {



  },
  methods: {



  }
}
</script>

<style lang='scss' scoped>
.list {
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  .item {
    width: 47.5%;
    background-color: #fff;
    padding: 1%;
    border-radius: 8px;
    margin-bottom: 24px;

    .echarts {
      width: 96%;
    }

    &:nth-child(odd) {
      margin-right: 1%;
    }

    .title {
      display: flex;
      justify-content: space-between;
    }

  }
}
</style>